import { useTheme } from '@mui/material';

export const IdentityStepTakePictureIcon = () => {
    const theme = useTheme();
    const mainColour = theme.colors.other.icon.stroke.primary;
    const borderColour = theme.colors.other.icon.background.primary;

    return (
        <svg
            width="176"
            height="124"
            viewBox="0 0 176 124"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.5946 31.2146C5.69966 16.0403 17.0155 0.5 32.9597 0.5H138.524C148.723 0.5 157.758 7.07881 160.889 16.7854L173.147 54.7854C174.66 59.4761 174.66 64.5239 173.147 69.2146L160.889 107.215C157.758 116.921 148.723 123.5 138.524 123.5H32.9597C17.0155 123.5 5.69966 107.96 10.5946 92.7854L18.0991 69.5216C19.6766 64.6313 19.6766 59.3687 18.0991 54.4784L10.5946 31.2146Z"
                fill="white"
                stroke="url(#linear1)"
            />
            <path
                opacity="0.05"
                d="M120.6 28.9999C123.9 37.1999 117.8 48.2999 111.5 56.1999C105.1 64.1999 98.6001 69.0999 92.4001 68.7999C86.3001 68.5999 80.5001 63.2999 75.4001 55.9999C70.3001 48.6999 65.8001 39.4999 68.7001 31.4999C71.5001 23.5999 81.8001 16.7999 93.2001 16.0999C104.7 15.3999 117.3 20.7999 120.6 28.9999Z"
                fill={mainColour}
            />
            <mask id="path-3-inside-1_657_18316" fill="white">
                <path d="M63.802 24.5403C63.3591 22.3761 64.7545 20.2625 66.9188 19.8196L101.208 12.802C103.372 12.3591 105.486 13.7545 105.929 15.9188L113.246 51.6724C113.689 53.8367 112.294 55.9503 110.129 56.3932L75.84 63.4108C73.6757 63.8537 71.5622 62.4583 71.1192 60.294L63.802 24.5403Z" />
            </mask>
            <path
                d="M63.802 24.5403C63.3591 22.3761 64.7545 20.2625 66.9188 19.8196L101.208 12.802C103.372 12.3591 105.486 13.7545 105.929 15.9188L113.246 51.6724C113.689 53.8367 112.294 55.9503 110.129 56.3932L75.84 63.4108C73.6757 63.8537 71.5622 62.4583 71.1192 60.294L63.802 24.5403Z"
                fill="white"
            />
            <path
                d="M71.1192 60.294L70.1396 60.4945L71.1192 60.294ZM101.208 12.802L101.409 13.7817L101.208 12.802ZM66.9188 19.8196L66.7183 18.8399L66.9188 19.8196ZM63.802 24.5403L64.7817 24.3398L63.802 24.5403ZM67.1193 20.7992L101.409 13.7817L101.008 11.8223L66.7183 18.8399L67.1193 20.7992ZM104.949 16.1193L112.266 51.8729L114.226 51.4719L106.909 15.7183L104.949 16.1193ZM109.929 55.4135L75.6395 62.4311L76.0405 64.3905L110.33 57.3729L109.929 55.4135ZM72.0989 60.0935L64.7817 24.3398L62.8223 24.7408L70.1396 60.4945L72.0989 60.0935ZM75.6395 62.4311C74.0163 62.7633 72.4311 61.7167 72.0989 60.0935L70.1396 60.4945C70.6932 63.1998 73.3352 64.9441 76.0405 64.3905L75.6395 62.4311ZM112.266 51.8729C112.599 53.4961 111.552 55.0813 109.929 55.4135L110.33 57.3729C113.035 56.8192 114.779 54.1773 114.226 51.4719L112.266 51.8729ZM101.409 13.7817C103.032 13.4495 104.617 14.4961 104.949 16.1193L106.909 15.7183C106.355 13.0129 103.713 11.2686 101.008 11.8223L101.409 13.7817ZM66.7183 18.8399C64.0129 19.3935 62.2686 22.0355 62.8223 24.7408L64.7817 24.3398C64.4495 22.7166 65.4961 21.1314 67.1193 20.7992L66.7183 18.8399Z"
                fill={mainColour}
                mask="url(#path-3-inside-1_657_18316)"
            />
            <rect
                opacity="0.1"
                x="67.7207"
                y="23.7384"
                width="35"
                height="30"
                rx="1"
                transform="rotate(-11.5663 67.7207 23.7384)"
                fill={mainColour}
            />
            <rect
                opacity="0.1"
                width="35"
                height="5.48509"
                rx="1"
                transform="matrix(0.979693 -0.200501 -0.200501 -0.979693 75.2373 60.4662)"
                fill={mainColour}
            />
            <defs>
                <linearGradient
                    id="linear1"
                    x1="88"
                    y1="0"
                    x2="88"
                    y2="124"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.6" stopColor={borderColour} />
                    <stop offset="1" stopColor="#ffffff" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
